var LoggerInstance = require("js-logger").get("ContactUs");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false,
	accountData: {},
	wizardCommunicationTypes: {}
};

var ContactUsStore = class extends AbstractStore {
	constructor(dispatcher) {
		super();
		this.dispatchToken = dispatcher.register(action => {
			switch (action.actionType) {
				case Constants.CONTACT_US_INITIALIZE:
					state.isDesignMode = action.isDesignMode;
					state.accountData = action.accountData;
					state.wizardCommunicationTypes = action.wizardCommunicationTypes;
					return true; // Don't emit change

				default:
					// no op
					return true;
			}

			this.emitChange();
			return true;
		});
	}

	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

module.exports = new ContactUsStore(Dispatcher);
